import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { CSSTransitionGroup } from 'react-transition-group';

class ProjectVideo extends Component {
  render() {
    const { value } = this.props;
    return (
      <CSSTransitionGroup
        component="div"
        className="project-media iframe"
        transitionName="videoFadeInUp"
        transitionEnter={true}
        transitionEnterTimeout={800}
        transitionLeave={false}
        transitionAppear={true}
        transitionAppearTimeout={800}
      >
        <iframe
          src={value}
          key={value}
          width="660"
          height="370"
          frameBorder="0"
          allowFullScreen
        />
      </CSSTransitionGroup>
    );
  }
}

ProjectVideo.propTypes = {
  value: PropTypes.string
};

export default ProjectVideo;



// WEBPACK FOOTER //
// ./src/components/ProjectVideo.js